(() => {
  const GLOBAL_KEY = '__mtBlackFridayAllProducts';
  const SECTION_SELECTOR = '[data-mt-blackfriday-all-products]';
  const renderFunctions = new WeakMap();

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll(document);
    return;
  }

  const findSections = (container = document) => {
    const sections = [];

    if (container?.matches?.(SECTION_SELECTOR)) sections.push(container);
    container?.querySelectorAll?.(SECTION_SELECTOR).forEach((section) => sections.push(section));

    return sections;
  };

  const formatCount = (template, count) => String(template || '').replace(/\[count\]/g, String(count));

  const initSection = (section) => {
    if (!section || section.dataset.allProductsInitialized === 'true') return;
    section.dataset.allProductsInitialized = 'true';

    const grid = section.querySelector('[data-product-grid]');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-all-products-item]'));
    const filters = Array.from(section.querySelectorAll('[data-collection-filter]'));
    const sort = section.querySelector('[data-product-sort]');
    const clear = section.querySelector('[data-clear-filters]');
    const count = section.querySelector('[data-product-count]');
    const empty = section.querySelector('[data-empty-message]');

    const render = () => {
      const selected = filters.filter((filter) => filter.checked).map((filter) => filter.value);
      const sortValue = sort?.value || 'featured';
      const orderedCards = [...cards].sort((first, second) => {
        if (sortValue === 'az' || sortValue === 'za') {
          const direction = sortValue === 'az' ? 1 : -1;
          return first.dataset.productTitle.localeCompare(second.dataset.productTitle, undefined, {
            sensitivity: 'base',
          }) * direction;
        }

        return Number(first.dataset.featuredIndex) - Number(second.dataset.featuredIndex);
      });

      const fragment = document.createDocumentFragment();
      let visibleCount = 0;

      orderedCards.forEach((card) => {
        const memberships = card.dataset.collections || '';
        const isVisible = selected.length === 0 || selected.some((handle) => memberships.includes(`|${handle}|`));
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
        fragment.append(card);
      });

      grid.append(fragment);

      if (count) count.textContent = formatCount(section.dataset.countMessage, visibleCount);
      if (empty) empty.hidden = visibleCount > 0;
    };

    filters.forEach((filter) => filter.addEventListener('change', render));
    sort?.addEventListener('change', render);
    clear?.addEventListener('click', () => {
      filters.forEach((filter) => {
        filter.checked = false;
      });

      if (sort?.querySelector('option[value="featured"]')) sort.value = 'featured';
      render();
    });

    renderFunctions.set(section, render);
    render();
  };

  const initAll = (container = document) => findSections(container).forEach(initSection);

  const handleCategoryLink = (event) => {
    const link = event.target.closest('[data-blackfriday-category-filter]');
    if (!link) return;

    const handle = link.dataset.blackfridayCategoryFilter;
    const targetId = String(link.getAttribute('href') || '').replace(/^#/, '');
    const target = targetId ? document.getElementById(targetId) : null;
    const section = target?.matches?.(SECTION_SELECTOR) ? target : document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    const filters = Array.from(section.querySelectorAll('[data-collection-filter]'));
    const matchingFilter = filters.find((filter) => filter.value === handle);
    if (!matchingFilter) return;

    filters.forEach((filter) => {
      filter.checked = filter === matchingFilter;
    });
    renderFunctions.get(section)?.();
  };

  window[GLOBAL_KEY] = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('click', handleCategoryLink);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findSections(event.target).forEach((section) => renderFunctions.delete(section));
  });
})();
